import React from 'react';
import '../less/index';
import Banner from '../../../../auxiliary-components/shared/Banner';
import FilesForDownload from '../../../../auxiliary-components/shared/FilesForDownload/views/file.c';
import banner_partners from '../img/banner_partners.png';
import winners_block_img from '../img/winners-block-img.png';
import hearts_img from '../img/hearts-img.png';
import price_img from '../img/price_img.png';
import clearBR from 'utils/clearBR';

export default function template() {
    const page = 'mc-gifts',
      isMobile = this.isViewportMobile(),
      filesForDownload = {
          data: [
              {title_ua: 'Додаткова документація',
                  name_ua: 'Офіційні правила акції<br>«Зігрівайтеся подарунками від àбанку та Mastercard»',
                  image_path: "/api/v1/media/img?path=PDF.png",
                  link_path_ua: '/static/MsGifts/ms_gifts_rules.pdf'}
          ]
      },
      scheduleStageData = [
          {stage: 'MC_GIFTS_WINNERS_SCHEDULE_TITLE_01', gift: 'MC_GIFTS_WINNERS_SCHEDULE_TEXT_01'},
          {stage: 'MC_GIFTS_WINNERS_SCHEDULE_TITLE_02', gift: 'MC_GIFTS_WINNERS_SCHEDULE_TEXT_02'},
          {stage: 'MC_GIFTS_WINNERS_SCHEDULE_TITLE_03', gift: 'MC_GIFTS_WINNERS_SCHEDULE_TEXT_03'},
          {stage: 'MC_GIFTS_WINNERS_SCHEDULE_TITLE_04', gift: 'MC_GIFTS_WINNERS_SCHEDULE_TEXT_04'},
      ],
      scheduleStageBlock = scheduleStageData.map(el => {
          return(
            <div className="winners-block-schedule-list-item" key={el.stage}>
                <div className="winners-block-schedule-list-item-title">{this.l10n(el.stage)}</div>
                <div className="winners-block-schedule-list-item-text" dangerouslySetInnerHTML={{ __html: this.l10n(el.gift) }}></div>
            </div>
          )
      });

    return (
      <div className='mc-gifts-module'>
        <Banner
          text={'MC_GIFTS_BANNER_TEXT'}
          textMob={'MC_GIFTS_BANNER_TEXT_MOB'}
          title={'MC_GIFTS_BANNER_TITLE'}
          page={page}
          dates={'MC_GIFTS_BANNER_HINT'}
          topImg={banner_partners}
          isMobile={isMobile}
        >
        </Banner>
          <div className="mc-gifts-content-wrapper">
              <div className="content">
                  <div className="counter-block">
                      <div className="title">{this.l10n('MC_GIFTS_COUNTER_TITLE')}</div>
                      <div className="counter-block-list">
                          <div className="counter-block-list-item">
                              <div
                                className="counter-block-list-item-title">
                                  {this.state.offerMembers}
                                  <img alt="hearts-img" src={hearts_img}/>
                              </div>
                              <div className="counter-block-list-item-text"
                                   dangerouslySetInnerHTML={{ __html: isMobile ? clearBR(this.l10n('MC_GIFTS_COUNTER_ITEM_01_TEXT')) : this.l10n('MC_GIFTS_COUNTER_ITEM_01_TEXT') }}></div>
                          </div>
                          <div className="counter-block-list-item">
                              <div className="counter-block-list-item-title">
                                  {this.state.transactionCount}
                                  <img alt="price_img" src={price_img} />
                              </div>
                              <div className="counter-block-list-item-text"
                                   dangerouslySetInnerHTML={{ __html: this.l10n('MC_GIFTS_COUNTER_ITEM_02_TEXT') }}></div>
                          </div>
                      </div>
                  </div>

                  <div className="rules-block">
                      <div className="title">{this.l10n('MC_GIFTS_RULES_TITLE')}</div>
                      <div className="rules-block-list">
                          <div className="rules-block-list-item">
                              <div
                                className="rules-block-list-item-title">{this.l10n('MC_GIFTS_RULES_ITEM_01_TITLE')}</div>
                              <div className="rules-block-list-item-text"
                                   dangerouslySetInnerHTML={{ __html: this.l10n('MC_GIFTS_RULES_ITEM_01_TEXT') }}></div>
                          </div>
                          <div className="rules-block-list-item">
                              <div
                                className="rules-block-list-item-title">{this.l10n('MC_GIFTS_RULES_ITEM_02_TITLE')}</div>
                              <div className="rules-block-list-item-text"
                                   dangerouslySetInnerHTML={{ __html: isMobile ? clearBR(this.l10n('MC_GIFTS_RULES_ITEM_02_TEXT')) : this.l10n('MC_GIFTS_RULES_ITEM_02_TEXT')}}></div>
                          </div>
                          <div className="rules-block-list-item">
                              <div
                                className="rules-block-list-item-title">{this.l10n('MC_GIFTS_RULES_ITEM_03_TITLE')}</div>
                              <div className="rules-block-list-item-text"
                                   dangerouslySetInnerHTML={{ __html: this.l10n('MC_GIFTS_RULES_ITEM_03_TEXT')}}></div>
                          </div>
                      </div>
                      <div className="rules-block-desc"  dangerouslySetInnerHTML={{ __html: this.l10n('MC_GIFTS_RULES_DESC')}}></div>
                  </div>

                  <div className="winners-block">
                      <div className="winners-block-schedule">
                          <div className="title">{this.l10n('MC_GIFTS_WINNERS_TITLE_01')}</div>
                          <div className="text" dangerouslySetInnerHTML={{ __html: isMobile ? clearBR(this.l10n('MC_GIFTS_WINNERS_TEXT_01')) : this.l10n('MC_GIFTS_WINNERS_TEXT_01')}}></div>
                          <div className="title">{this.l10n('MC_GIFTS_WINNERS_TITLE_02')}</div>
                          <div className="winners-block-schedule-list">
                              {scheduleStageBlock}
                          </div>
                      </div>
                      <img className="winners-block-img" src={winners_block_img} alt="winners-block-img"/>
                  </div>
                  <FilesForDownload lang={this.props.lang} widget={filesForDownload}/>
              </div>
          </div>
      </div>
    );
}
